module.exports = __webpack_public_path__ + "img/instagram-d.6b6ebb40.svg";